import React, { useState, useRef, useEffect } from 'react';

function TerminalInput({ isOpen, onSubmit, onClose, response, history, npcName }) {
  const [input, setInput] = useState('');
  const inputRef = useRef(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [isOpen]);

  // Auto-scroll to bottom when history updates
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [history, response]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      onSubmit(input.trim());
      setInput('');
    }
  };

  if (!isOpen) return null;

  const displayName = npcName || 'AXIOM-7';

  return (
    <div className="terminal-overlay" onClick={(e) => {
      if (e.target.classList.contains('terminal-overlay')) onClose();
    }}>
      <div className="terminal-container">
        <div className="terminal-header">
          <div className="terminal-dots">
            <span className="dot dot-red" />
            <span className="dot dot-yellow" />
            <span className="dot dot-green" />
          </div>
          <span className="terminal-title">{displayName} DIRECT INTERFACE</span>
          <button className="terminal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="terminal-body" ref={bodyRef}>
          <div className="terminal-history">
            <div className="terminal-welcome">
              {displayName} Terminal v2.4.1 | Type a command and press Enter
            </div>

            {/* Render full command history */}
            {history && history.map((entry, i) => (
              <div key={i} className="terminal-history-entry">
                <div className="terminal-history-input">
                  <span className="terminal-history-prompt">&gt;</span> {entry.input}
                </div>
                <div className={`terminal-response ${entry.response.isGenius ? 'terminal-genius-response' : ''}`}>
                  {entry.response.text.split('\n').map((line, j) => (
                    <div key={j} className={line === '' ? 'terminal-blank' : 'terminal-line'}>
                      {line}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <form className="terminal-form" onSubmit={handleSubmit}>
            <span className="terminal-prompt">&gt;</span>
            <input
              ref={inputRef}
              className="terminal-input"
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="enter command..."
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default TerminalInput;
